(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[726],{

/***/ 699:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/default-splash-card.0ded0b20.png","height":1667,"width":1667,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAAqElEQVR42iWOOQrCABBF5wiC4lKIW+GWmEWSVo8QUAhoE21SBtLmDIE0aXOAtDmC1mlyn4cZhAczzPzP/4JhYjs4Lu5Zl5OFeeoRHZMZgyEizBcslmx3/Vs4GjyevN4kCbc7QcDlym4veD5VRdPQddQ1aUoUsVqLGsNQhWVJ2/L5kueIiKatN4iQZRSFXuOY0Vi0lWVrq/0BEWU8xXa01R+1en6PigzzB2D/YcmSCI2wAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 2296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ BlogHorizontal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react_infinite_scroll_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8533);
/* harmony import */ var react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8182);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var src_shared_functions_dateFormat__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9847);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _atk_components_loaders_ListLoader_ListLoader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1608);
/* harmony import */ var _atk_hooks_framerMotion__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(658);
/* harmony import */ var _BlogHorizontal_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2628);
/* harmony import */ var _BlogHorizontal_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_BlogHorizontal_module_scss__WEBPACK_IMPORTED_MODULE_6__);









function BlogHorizontal(param) {
    let { list , isLoading , hasNextPage , fetchNextPage , customClass , desc , date , footer , withoutFeatured  } = param;
    const componentClass = "BlogHorizontal ".concat(customClass !== null && customClass !== void 0 ? customClass : "");
    const blogList = list;
    var _externalLink, _webpThumbnailUrl, _categoryName, _preview, _legendDate;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: componentClass,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_infinite_scroll_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            className: (_BlogHorizontal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().overflow),
            dataLength: blogList ? blogList.length : 0,
            next: ()=>fetchNextPage(),
            hasMore: hasNextPage || isLoading,
            loader: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atk_components_loaders_ListLoader_ListLoader__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}),
            scrollThreshold: 0.5,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_BlogHorizontal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().masonryWrapper),
                children: blogList && blogList.map((p, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: index === 0 && !withoutFeatured ? "d-none" : "",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atk_hooks_framerMotion__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                className: "text-decoration-none",
                                href: (_externalLink = p.externalLink) !== null && _externalLink !== void 0 ? _externalLink : "/blog/".concat(p.meta.slug),
                                legacyBehavior: true,
                                passHref: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: (_BlogHorizontal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().cardLink),
                                    target: p.externalLink ? "_blank" : "_self",
                                    rel: "noopener noreferrer",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                        className: (_BlogHorizontal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().blogItem),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                src: (_webpThumbnailUrl = p.webpThumbnailUrl) !== null && _webpThumbnailUrl !== void 0 ? _webpThumbnailUrl : "",
                                                alt: "Casper Labs",
                                                fill: true,
                                                className: "card-img-top position-relative"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_7__/* ["default"].Body */ .Z.Body, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "half-title categoryName",
                                                        children: (_categoryName = p.categoryName) !== null && _categoryName !== void 0 ? _categoryName : ""
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_7__/* ["default"].Title */ .Z.Title, {
                                                        children: p.title
                                                    }),
                                                    desc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_7__/* ["default"].Text */ .Z.Text, {
                                                        dangerouslySetInnerHTML: {
                                                            __html: (_preview = p.preview) !== null && _preview !== void 0 ? _preview : ""
                                                        }
                                                    }),
                                                    date && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "date",
                                                        children: "".concat((_legendDate = p.legendDate) !== null && _legendDate !== void 0 ? _legendDate : "").concat((0,src_shared_functions_dateFormat__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(p.timePublished))
                                                    })
                                                ]
                                            }),
                                            footer && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_7__/* ["default"].Footer */ .Z.Footer, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("small", {
                                                    className: "text-muted",
                                                    children: p.state
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    }, p._id))
            })
        })
    });
}


/***/ }),

/***/ 3065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CustomHead; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _assets_img_default_splash_card_png__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(699);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7294);





const baseUrl = "https://www.casperlabs.io/";
const siteName = "Casper Labs";
function CustomHead(param) {
    let { title , description ="" , og , twitter , business , children  } = param;
    if (!og) {
        og = {
            ogTitle: title,
            ogDescription: description,
            ogImage: _assets_img_default_splash_card_png__WEBPACK_IMPORTED_MODULE_3__/* ["default"].src */ .Z.src
        };
    }
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const key = (0,react__WEBPACK_IMPORTED_MODULE_4__.useId)();
    const ogUrl = "".concat(baseUrl.substring(0, baseUrl.length - 1)).concat(router.asPath);
    return(// eslint-disable-next-line @next/next/no-script-component-in-head
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/x-icon",
                href: "/favicon.ico"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "192x192",
                href: "/android-chrome-192x192.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "512x512",
                href: "/android-chrome-512x512.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "preload",
                href: "".concat(baseUrl, "icons/navbar-toggle-icon.webp"),
                as: "image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "author",
                content: "Casper Labs"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "googlebot",
                content: "all"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "bingbot",
                content: "all"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "all"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "facebook-domain-verification",
                content: "5dpoinx6gwzawxktv7aakmzim1f23c"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: siteName
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:width",
                content: "1200"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:height",
                content: "630"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: og.ogTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: og.ogDescription
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: ogUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: og.ogImage
            }),
            twitter && Object.keys(twitter).map((p)=>{
                const content = twitter[p];
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:".concat(p),
                    content: content
                }, key + p);
            }),
            business && Object.keys(business).map((p)=>{
                const content = business[p];
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "business:contact_data:".concat(p),
                    content: content
                }, key + p);
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: ogUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "manifest",
                href: "/manifest.json"
            }),
            children
        ]
    }));
}


/***/ }),

/***/ 1608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ListLoader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4051);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1555);
/* harmony import */ var react_bootstrap_Spinner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6968);
/* harmony import */ var _ListLoader_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5973);
/* harmony import */ var _ListLoader_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_ListLoader_module_scss__WEBPACK_IMPORTED_MODULE_1__);




function ListLoader() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_ListLoader_module_scss__WEBPACK_IMPORTED_MODULE_1___default().loaderContainer),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            className: "mt-5",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                md: "auto",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Spinner__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    className: "text-green",
                    animation: "border",
                    role: "status",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "visually-hidden",
                        children: "Loading..."
                    })
                })
            })
        })
    });
}


/***/ }),

/***/ 7654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Newsletter2; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(4051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(1555);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/@shared/components/loaders/ListLoader/ListLoader.tsx
var ListLoader = __webpack_require__(1608);
// EXTERNAL MODULE: ./src/@shared/hooks/useHotspotForm.ts
var useHotspotForm = __webpack_require__(7602);
;// CONCATENATED MODULE: ./src/@shared/components/layout/Modal/HubspotForm.tsx




function HubspotForm(param) {
    let { formId , target , children , onFormSubmitted  } = param;
    const { loading , initHotspotForm , show  } = (0,useHotspotForm/* default */.Z)({
        region: "na1",
        portalId: "6073987",
        formId,
        target,
        autohide: true
    });
    (0,react.useEffect)(()=>{
        const timerHubspot = setTimeout(()=>{
            initHotspotForm();
        }, 1000);
        return ()=>{
            clearTimeout(timerHubspot);
        };
    }, []);
    (0,react.useEffect)(()=>{
        if (onFormSubmitted) onFormSubmitted(show);
    }, [
        onFormSubmitted,
        show
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListLoader/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "formContainer",
                children: children
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/@shared/hooks/framerMotion.tsx
var framerMotion = __webpack_require__(658);
// EXTERNAL MODULE: ./src/@shared/components/newsletter/Newsletter2/Newsletter2.module.scss
var Newsletter2_module = __webpack_require__(8877);
var Newsletter2_module_default = /*#__PURE__*/__webpack_require__.n(Newsletter2_module);
;// CONCATENATED MODULE: ./src/@shared/components/newsletter/Newsletter2/Newsletter2.tsx






function Newsletter2(param) {
    let { title , desc , col1 , col2 , customClass  } = param;
    const componentClass = "newsLetter2 ".concat((Newsletter2_module_default()).newsLetter2, " ").concat(customClass !== null && customClass !== void 0 ? customClass : "");
    const [submitted, setSubmitted] = (0,react.useState)(false);
    const onFormSubmitted = (value)=>{
        setSubmitted(value !== null && value !== void 0 ? value : false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: componentClass,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(framerMotion/* default */.Z, {
            y: 100,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                    className: "align-items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                            md: col1 ? col1 : 6,
                            className: (Newsletter2_module_default()).title,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "h3 mb-4 mb-lg-0",
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mb-4 mb-lg-0",
                                    children: desc
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            md: col2 ? col2 : 6,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "position-relative",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HubspotForm, {
                                    formId: "1f65e0fe-b2be-4ee0-986d-ac8f8821f529",
                                    target: "#getCTANewsletterHubspot",
                                    onFormSubmitted: onFormSubmitted,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            id: "getCTANewsletterHubspot"
                                        }),
                                        !submitted && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "inputArrow",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                width: "12",
                                                height: "11",
                                                viewBox: "0 0 10 8",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M0.997559 4.00021H9.00205M9.00205 4.00021L5.8578 0.855957M9.00205 4.00021L5.8578 7.14447",
                                                        stroke: "#fff"
                                                    }),
                                                    " "
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
}


/***/ }),

/***/ 9847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ shortMonthDateBlog; }
/* harmony export */ });
function shortMonthDateBlog(dateData) {
    const date = new Date(dateData);
    const formattedDate = date.toLocaleDateString("en-EN", {
        month: "short",
        day: "numeric",
        year: "numeric"
    });
    return formattedDate;
}


/***/ }),

/***/ 658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FramerMotion; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3838);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);



function FramerMotion(param) {
    let { children , animation ="fadeUp" , y  } = param;
    const [isMobile, setIsMobile] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setIsMobile(window.innerWidth <= 768);
        const handleResize = ()=>{
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    if (isMobile) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: children
    });
    const fadeInProps = {
        initial: {
            opacity: 0
        },
        animate: {
            opacity: 1
        },
        exit: {
            opacity: 0
        }
    };
    const fadeUpProps = {
        initial: {
            opacity: 0,
            y: y && y || 250
        },
        whileInView: {
            opacity: 1,
            y: 0
        },
        transition: {
            type: "spring",
            stiffness: 50,
            duration: 2
        },
        viewport: {
            once: true
        },
        className: "framerMotion"
    };
    const animationProps = animation === "fadeIn" ? fadeInProps : fadeUpProps;
    const { ...motionProps } = animationProps;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .motion.div */ .E.div, {
        ...motionProps,
        children: children
    });
}


/***/ }),

/***/ 7602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useHotspotForm; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

const reducer = (currentState, newState)=>{
    return {
        ...currentState,
        ...newState
    };
};
function useHotspotForm(param) {
    let { region , portalId , formId , target , autohide  } = param;
    const initialState = {
        loading: true,
        show: false
    };
    const [{ loading , show  }, setState] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(reducer, initialState);
    const toggleShow = ()=>setState({
            show: !show
        });
    const noShow = ()=>{
        setState({
            show: false
        });
        initHotspotForm();
    };
    const initHotspotForm = ()=>{
        hbspt.forms.create({
            region,
            portalId,
            formId,
            target,
            onFormReady: ()=>{
                setState({
                    loading: false
                });
            },
            onBeforeFormInit: (ctx)=>{
                if (ctx.pageUrl) {
                    setState({
                        loading: false
                    });
                }
            },
            onFormSubmitted: function() {
                setState({
                    show: true
                });
                if (autohide) {
                    const timerHubspot = setTimeout(()=>{
                        noShow();
                    }, 5000);
                    return ()=>{
                        clearTimeout(timerHubspot);
                    };
                }
            }
        });
    };
    return {
        loading,
        show,
        toggleShow,
        noShow,
        initHotspotForm
    };
}


/***/ }),

/***/ 2628:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"overflow":"BlogHorizontal_overflow___97le","masonryWrapper":"BlogHorizontal_masonryWrapper__Qpbw4","blogItem":"BlogHorizontal_blogItem__pYuP_","cardLink":"BlogHorizontal_cardLink__Emuqo"};

/***/ }),

/***/ 5973:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"ListLoader_loaderContainer__hS6rF"};

/***/ }),

/***/ 8877:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"newsLetter2":"Newsletter2_newsLetter2__S1IQd","form":"Newsletter2_form____nD9","title":"Newsletter2_title__CRAYf","spinner":"Newsletter2_spinner__LNCxl"};

/***/ })

}]);